import React from 'react';
import { Flex } from '@televet/kibble-ui/build/chakra';
import { Icon } from '@televet/kibble-ui/build/components/Icon';
import { Text } from '@televet/kibble-ui/build/components/Text';

interface ISuggestedOption {
  textContent: string;
  isSelected: boolean;
  onSelect: () => void;
  noRadial?: boolean;
  petParentPimsId?: string;
  isClientIdSupported?: boolean;
}

const SuggestedOption = ({
  textContent,
  isSelected,
  onSelect,
  noRadial,
  petParentPimsId,
  isClientIdSupported,
}: ISuggestedOption): JSX.Element => {
  const displayId = !!isClientIdSupported && !!petParentPimsId;
  return (
    <Flex
      onClick={onSelect}
      boxShadow="md"
      borderRadius="md"
      borderWidth="1px"
      borderColor={isSelected ? 'border.focus' : 'border.default'}
      cursor="pointer"
      minHeight="30px"
      px={2}
      py={1}
      alignItems="center"
      gap={2}
      mb={1}
    >
      {!noRadial && <Icon size="sm" name="checkmarkCircle" variant={isSelected ? 'interactive' : 'subtleOnContrast'} />}
      <Text>{`${textContent}${displayId ? ` ID: ${petParentPimsId}` : ''}`}</Text>
    </Flex>
  );
};

export default SuggestedOption;
